import { useBlueskyLogin, UseBlueskyLoginConfig } from '@sparemin/auth';
import { useDispatch, useSelector } from 'react-redux';
import { pick } from 'underscore';
import { tokenSelector } from 'redux/modules/auth';
import {
  blueskyAuthorizeSuccess,
  clearBlueskyUser,
  waitForBlueskyProfile,
} from 'redux/modules/social';
import { Dispatch } from 'redux/types';
import { FatalError } from 'utils/FatalError';

export interface UseBlueskyAuthenticatorConfig
  extends Pick<UseBlueskyLoginConfig, 'force' | 'appRedirectUrl' | 'onError'> {
  onAuthSuccess?: () => void;
  defaultAuthenticated?: boolean;
}

export default function useBlueskyAuthenticator({
  force,
  appRedirectUrl,
  onAuthSuccess,
  onError,
  defaultAuthenticated,
}: UseBlueskyAuthenticatorConfig) {
  const dispatch = useDispatch<Dispatch>();
  const spareminToken = useSelector(tokenSelector);

  return useBlueskyLogin({
    force,
    appRedirectUrl,
    spareminToken,
    defaultAuthenticated,
    onSuccess: async data => {
      dispatch(clearBlueskyUser());

      if (data) {
        dispatch(
          blueskyAuthorizeSuccess(
            pick(
              data.tokenInfo,
              'accessToken',
              'accessTokenSecret',
              'idToken',
              'providerUserId',
            ),
          ),
        );
      }

      try {
        await dispatch(waitForBlueskyProfile());

        onAuthSuccess?.();
      } catch (error) {
        throw new FatalError(error.message);
      }
    },
    onError,
  });
}
